export namespace ACTIVITY_FEED_EVENT_TYPE {
    export const SMS_RECEIVED = "sms-received"
    export const CHAT_MESSAGE_RECEIVED = "chat-message-received"
    export const DOCUMENT_SIGNED = "signed-document-message-received"
    export const QUOTE_STATUS_APPROVED = "quote-status-approved"
    export const QUOTE_STATUS_DECLINED = "quote-status-declined"
    export const QUOTE_PAYMENT_CAPTURED = "quote-payment-captured"
    export const INVOICE_PAYMENT_CAPTURED = "invoice-payment-captured"
    export const ORDER_PAYMENT_CAPTURED = "order-payment-captured"
    export const INVOICE_SYNC_RECEIVED = "invoice-sync-error-received"
}

export type ActivityFeedNotifications = typeof ACTIVITY_FEED_EVENT_TYPE[keyof typeof ACTIVITY_FEED_EVENT_TYPE]




// WEBPACK FOOTER //
// ./src/state/activity-feed/ActivityFeedEventType.ts